export const CONTROL_BAR_WIDTH = "w-[560px] max-w-[60vw]";
export const CONTROL_BAR_HEIGHT = "h-[56px]";
export const CONTROL_BAR_MIN_HEIGHT = "min-h-[56px]";
